import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-terms-and-conditions',
  template: `
    <h2>Términos y Condiciones</h2>
    <ng-container *ngIf="pdfUrl; else loading" style="height: 100vh">
      <iframe
        [src]="pdfUrl | safeUrl"
        width="100%"
        height="500px"
        style="border: none;"
        title="Términos y Condiciones PDF"
      ></iframe>
    </ng-container>
    <ng-template #loading>
      <p>Cargando...</p>
    </ng-template>
  `,
  styles: [':host { display: block; padding: 16px; height: 100%; }'],
})
export class TermsAndConditionsPage implements OnInit {
  pdfUrl: string | null = null;

  constructor(private userService: UserService) {}

  ngOnInit() {
    this.userService.getLatestTermsAndConditions().subscribe((data: any) => {
      this.pdfUrl = data.pdf_file ? `${data.pdf_file}#view=FitH` : null;
    });
  }
}
